
const validateDataForZero =(data) => {
    let zeroNotExist = false; 
    if((data.form_config.AUM_EXIT) && data[data.form_config.KEY]){ 
        data[data.form_config.KEY].forEach((element, index) => {
            if (Number(element.min_disb_per) === 0 || Number(element.max_disb_per) ===0 ) {
                zeroNotExist = true;
            }
        });
    }

    if((data.form_config.FRESH_GMV) && data[data.form_config.KEY]){ 
        data[data.form_config.KEY].forEach((element, index) => {
            if (Number(element.min_disb_per) === 0 || Number(element.max_disb_per) ===0 ) {
                zeroNotExist = true;
            }
        });
    }

    if((data.form_config.ACTIVATION) && data[data.form_config.KEY]){ 
        if (Number(data.threshold_gmv) === 0) {
            zeroNotExist = true;
        }
        if (Number(data.dealer_remaining_limit) === 0) {
            zeroNotExist = true;
        }
        data[data.form_config.KEY].forEach((element) => {
            if (Number(element.min_disb_per) === 0 || Number(element.max_disb_per) ===0 ) {
                zeroNotExist = true;
            }
        });
    }

    if(data.form_config.NCL && data[data.form_config.KEY]){ 
        data[data.form_config.KEY].forEach((element, index) => {
            if (Number(element.min_disb_per) === 0 && Number(element.max_disb_per) === 0) {
                zeroNotExist = true;
            }
        });
    }

    if (data.sub_schemes && data.sub_schemes.length) {
        data.sub_schemes.forEach(subScheme => {
            if (subScheme.sub_scheme_details && subScheme.sub_scheme_details.length) {
                subScheme.sub_scheme_details.forEach(subSchemeDetailRow => {
                    if (Number(subSchemeDetailRow.min_value) === 0 && Number(subSchemeDetailRow.max_value) === 0) {
                        zeroNotExist = true;
                    }
                })
            }
        })
    }
    return zeroNotExist;
};

export default validateDataForZero;